module.exports = __webpack_public_path__ + "static/media/pregnancy-icon.d11b4a82.svg";